import { Event } from "./Event"
import { State } from "./State"

export class Workflow {
  name: string
  transitions: Array<Transition> = []

  constructor(name: string) {
    this.name = name
    this.transitions = []
  }
}

export class Transition {
  workflowName?: string
  from: State
  to: State
  event: Event
  secondary: boolean
  requireOnline: boolean
  needsCompletion: boolean
  impersonate: boolean

  constructor(
    workflowName: string,
    from: State,
    to: State,
    event: Event,
    secondary: boolean = false,
    requireOnline: boolean = false,
    needsCompletion: boolean = false,
    impersonate: boolean = false,
  ) {
    if (workflowName) {
      this.workflowName = workflowName
    }
    this.from = from
    this.to = to
    this.event = event
    this.secondary = secondary
    this.requireOnline = requireOnline
    this.needsCompletion = needsCompletion
    this.impersonate = impersonate
  }
}
